<template>
  <div>
    <div v-for="(item, index) in items" :key="index">
      {{ item }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    results: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    items() {
      return JSON.parse(this.results);
    },
  },

  created() {
    // axios
    //   .get('/articles/refine/?q=:relevance')
    //   .then(response => console.log(response))
    //   .catch(error => console.log(error))
  },
};
</script>
